import React, { useEffect, useState } from 'react'
import { useAlert } from '../../../contexts/AlertContext'
import CustomAlert from './Alert'
import './GlobalAlert.css'

const AUTO_CLOSE_DELAY = 5000

const GlobalAlert = () => {
  const { alert, closeAlert } = useAlert()
  const { open, severity, message, validationErrors = [] } = alert
  const isValidation = validationErrors.length > 0

  const [show, setShow] = useState(open || isValidation)

  useEffect(() => {
    if (open || isValidation) {
      setShow(true)

      if (!isValidation) {
        const timer = setTimeout(() => {
          setShow(false)
          closeAlert()
        }, AUTO_CLOSE_DELAY)

        return () => clearTimeout(timer)
      }
    }
  }, [open, isValidation, closeAlert])

  if (!show) return null

  return (
    <div className={`global-alert-wrapper ${show ? 'fade-in' : 'fade-out'}`}>
      <CustomAlert
        severity={severity || 'info'}
        onClose={() => {
          setShow(false)
          closeAlert()
        }}
        validationErrors={validationErrors}
        message={message}
      />
    </div>
  )
}

export default GlobalAlert
